import script from "./ForumCreatePost.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumCreatePost.vue?vue&type=script&setup=true&lang=js"

import "./ForumCreatePost.vue?vue&type=style&index=0&id=6efbd6f1&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6efbd6f1"]])

export default __exports__